import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-organizer-star',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './organizer-star.component.html',
  styleUrl: './organizer-star.component.scss'
})
export class OrganizerStarComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.organizerStar;
}
